import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-11-21T13:00:00Z").getTime();

function getParts(diff) {
  const clamp = Math.max(0, diff);
  const days = Math.floor(clamp / (1000 * 60 * 60 * 24));
  const hours = Math.floor((clamp / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((clamp / (1000 * 60)) % 60);
  const seconds = Math.floor((clamp / 1000) % 60);
  return { days, hours, minutes, seconds };
}

const Countdown = () => {
  const [parts, setParts] = useState(() => getParts(TARGET - Date.now()));

  useEffect(() => {
    const t = setInterval(() => setParts(getParts(TARGET - Date.now())), 1000);
    return () => clearInterval(t);
  }, []);

  const items = [
    { label: "Days", value: parts.days },
    { label: "Hours", value: parts.hours },
    { label: "Minutes", value: parts.minutes },
    { label: "Seconds", value: parts.seconds },
  ];

  return (
    <div className="countdown" data-testid="countdown">
      {items.map((it) => (
        <div className="cd-unit" key={it.label}>
          <div className="cd-value" data-testid={`cd-${it.label.toLowerCase()}`}>
            {String(it.value).padStart(2, "0")}
          </div>
          <div className="cd-label">{it.label}</div>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
